module.exports = __webpack_public_path__ + "static/img/reservation-spep-3.5dc9b98.png";